<template>
  <div class="call_back" style="background-image: url('/img/callback.jpg')">
    <b-container class="py-5">
      <div class="call_back-card">
        <b-icon
          icon="check2-circle"
          style="width: 120px; height: 120px; color: #669944;"
        ></b-icon>
        <h5 class="my-3 call_back-card_title">
          謝謝您的訂購，廠商將指派業務與你聯繫。
          <br />
          若有其他問題，請詳閱
          <a href="/shopping-note" target="_blank">"訂購說明"</a>
        </h5>
        <table class="table table-striped table-bordered my-5">
          <thead>
            <tr>
              <th scope="col" class="text-left">訂單編號</th>
              <th scope="col" class="text-left">廠商</th>
              <th scope="col" class="text-center">總金額</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="iten in oderData" :key="iten.order_serial">
              <th class="text-left">{{ iten.order_serial }}</th>
              <th class="text-left">{{ iten.company_name }}</th>
              <th class="text-right">{{ getDetailPrice(iten.detail) }}</th>
            </tr>
          </tbody>
        </table>
        <div>
          <router-link :to="{ name: '訂單查詢' }" v-slot="{ href }">
            <b-button :href="href" squared variant="platform_sub" class="mb-3"
              >前往查看訂單內容</b-button
            >
          </router-link>
        </div>
        <div>
          <b-button href="/" squared variant="platform_main" class="mb-3"
            >回首頁</b-button
          >
        </div>
      </div>
    </b-container>
  </div>
</template>
<style lang="scss" scoped>
.call_back {
  min-height: calc((var(--vh, 1vh) * 100) - 104px - 64px - 35px);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  &-card {
    background-color: rgba(#fff, 0.9);
    padding: 30px;
    text-align: center;
    &_title {
      font-weight: bold;
      line-height: 1.8;
      a {
        color: $platform-main;
      }
    }
  }
}
</style>
<script>
import { ShoppingCar, Order } from "@/assets/api/platform.js";
import { Toast } from "@/plugins/sweetalert2.js";

export default {
  name: "CallBack",
  props: ["token"],
  data() {
    return {
      oderData: []
    };
  },
  created() {
    this.getShoppingCar();
    this.getOderNub();
  },
  methods: {
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
    },
    getOder(id) {
      let config = Object.assign({}, this.token);
      config.params = {
        serial_no: id
      };
      Order.get(config)
        .then(res => {
          if (res.status <= 201) {
            this.oderData.push(res.data.data[0]);
          } else {
            Toast.fire({
              icon: "error",
              title: "訂單資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    getOderNub() {
      this.oderData = [];
      this.$route.params.id.split("&").forEach(val => {
        this.getOder(val);
      });
    },
    getDetailPrice(detail) {
      let total = 0;
      detail.forEach(val => {
        total += Number(val.price) * Number(val.count);
      });
      return this.toThousands(total);
    },
    getShoppingCar() {
      ShoppingCar.get(this.token)
        .then(res => {
          if (res.status <= 201) {
            const shopping_car = res.data;
            let newQty = 0;
            Object.keys(shopping_car).forEach(key => {
              newQty = newQty + shopping_car[key].items.length;
            });
            this.$emit("shoppingCarQty", newQty);
          } else {
            Toast.fire({
              icon: "error",
              title: "購物車資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>
